export default "__VITE_ASSET__rWEwl$bI__"